<div class="spotlight-container">
  <div class="spotlight" #spotlight></div>
</div>

<div class="d-flex flex-row content-container">
  <section class="ion-hide-md-down menus">
    <div class="p-3">
      <catalog-side-menus
        class="ion-hide-md-down overflow-hidden"
        [menus]="menus"
        [value]="selectedMenu"
        [totalCount]="getTotalItems()"
        (menuClick)="onMenuClick($event)"
      ></catalog-side-menus>
    </div>
  </section>

  <section class="p-3 flex-grow-1 items" #scrollRef>
    <ion-item *ngIf="!isUserLoggedIn" class="mt-4 pt-2 mt-sm-1">
      <ion-label class="info-title text-center"
        >Please
        <a href="#" routerLink="/login" class="custom-signin-btn">Sign In</a> or
        <a href="#" routerLink="/sign-up" class="custom-signin-btn">Sign Up</a>
        to place any order</ion-label
      >
    </ion-item>

    <div class="p-4 pb-0 toolbar-container">
      <section>
        <app-search-bar
          placeholder="Search items here..."
          (searchChange)="searchFoodItems($event)"
        ></app-search-bar>
      </section>

      <ion-toolbar>
        <ion-title class="page-title p-0">
          <span class="link-ref" id="AllMenus"></span>
          <span [innerText]="getTotalItems()"></span>
          <span translate="FOOD_ITEMS" class="mx-2"></span>
        </ion-title>
      </ion-toolbar>
      <ng-content select="[header]"></ng-content>
    </div>

    <ion-grid *ngIf="isLoading">
      <ion-row *ngFor="let menu of menus">
        <ion-col size="12">
          <h3
            (sdAppear)="onAppear($event, menu)"
            [scrollRef]="scrollRef"
            [spotlightRef]="spotlight"
          >
            <span [innerText]="menu?.menuName"></span>
            <span class="link-ref" [id]="menu?.menuId"></span>
          </h3>
        </ion-col>

        <ion-col
          size="12"
          size-sm="6"
          size-md="12"
          size-lg="6"
          size-xl="4"
          *ngFor="let mapping of menu?.itemsMappings"
        >
          <ion-card class="item">
            <ng-container *ngIf="mapping?.menuItem as item">
              <div
                class="thumbnail"
                *ngIf="item?.iconImage; else elsePreview"
                [style.background-image]="'url(' + item?.iconImage?.url + ')'"
              >
                <app-food-type-indicator
                  [ngClass]="item?.vegetarian ? 'veg' : 'non-veg'"
                ></app-food-type-indicator>
              </div>
              <ng-template #elsePreview>
                <div class="thumbnail">
                  <app-food-type-indicator
                    [ngClass]="item?.vegetarian ? 'veg' : 'non-veg'"
                  ></app-food-type-indicator>
                </div>
              </ng-template>

              <ion-card-header class="ion-text-capitalize">
                <ion-card-title
                  class="mt-2"
                  [innerText]="item?.name"
                ></ion-card-title>

                <ion-card-subtitle class="tags" *ngIf="item?.tags?.length">
                  <ion-icon name="pricetags-outline"></ion-icon>
                  <span [innerText]="item?.tags?.join(', ')"></span>
                </ion-card-subtitle>

                <ion-card-subtitle
                  *ngIf="catalogDetails?.restaurantBranchId"
                  class="price"
                  [ngClass]="{ 'no-pointer': true }"
                >
                  <span>Price: </span>
                  <ng-container *ngIf="mapping?.priceDetails?.active">
                    <span
                      class="color-dark amount"
                      *ngIf="mapping?.priceDetails?.price as price"
                      >{{ mapping?.currencyModel?.currencysymbol }}
                      <span [innerText]="price"></span
                    ></span>
                  </ng-container>
                  <span
                    class="color-danger"
                    *ngIf="
                      !mapping?.priceDetails?.active ||
                      !mapping?.priceDetails?.price
                    "
                    ><b>Unavailable</b></span
                  >
                </ion-card-subtitle>
              </ion-card-header>

              <ion-card-content *ngIf="item?.itemQuantity" class="quantity-info">
                <span class="" [innerText]="item?.itemQuantity?.value"></span>
                <span
                  class=""
                  [innerText]="item?.itemQuantity?.measurementUnit"
                ></span>
              </ion-card-content>
              <ion-card-content>
                <div class="description" [innerText]="item?.description"></div>
                <div *ngIf="mapping?.priceDetails?.price > 0">
                  <div
                    class="description text-success"
                    *ngIf="item?.offerRuleModel"
                  >
                    <strong
                      >Offer
                      {{
                        item?.offerRuleModel?.offerRuleType ==
                        "FLAT_FIXED_DISCOUNT"
                          ? mapping?.currencyModel?.currencysymbol +
                            " " +
                            item?.offerRuleModel?.discountFlatRate +
                            " Flat"
                          : item?.offerRuleModel?.discountPercRate + "%"
                      }}
                      off</strong
                    >
                  </div>
                </div>

                <ion-item>
                  <ion-input
                    placeholder="Special Notes"
                    type="text"
                    [(ngModel)]="specialNote[item?.itemId]"
                  ></ion-input>
                </ion-item>
              </ion-card-content>

              <div
                class="p-1 ion-text-center cart-mgmt"
                *ngIf="mapping?.cartItem && isUserLoggedIn"
              >
                <app-quantity-selector
                  lines="none"
                  [value]="mapping?.cartItem?.quantity"
                  [disabled]="
                    !mapping?.priceDetails?.price || !mapping.cartItem
                  "
                  (change)="onQuantityChange($event, mapping)"
                >
                </app-quantity-selector>
              </div>
            </ng-container>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </section>
</div>

<ion-fab vertical="top" horizontal="end" slot="fixed" class="ion-hide-md-up">
  <ion-fab-button (click)="onMenuListClick()" class="custom-fab-button">
    <ion-icon name="restaurant-outline" class="custom-fab-icon"></ion-icon>
    <ion-label class="mx-1 label-text">Menu</ion-label>
  </ion-fab-button>
</ion-fab>
